module.exports = __webpack_public_path__ + "static/media/gal06025.f9fb486d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal06/gal06025.jpg
// module id = 500
// module chunks = 0